module.exports = __webpack_public_path__ + "384bd42294d10764ba45c4bfd3ffd3e6.svg";


//////////////////
// WEBPACK FOOTER
// ./images/social-facebook.svg
// module id = 5T3h
// module chunks = 0